import {TitlePage} from "../../shared";
import {SquadflixHeaderType, UserPreferences} from "../hooks/";
import {useIntl} from "react-intl";
import {InputToggle} from "../user-app-config";
import ButtonV2 from "../../shared/button-v2/button-v2";
import {ScrollModal, ScrollModalApi} from "../../shared/scroll-modal";
import {useRef} from "react";

type Props = {
    userPreferences: UserPreferences;
    updatePreference: (key: keyof UserPreferences, value: any) => Promise<void>;
    loadingUpdate: boolean;
}

const toggles = [
    "showLaLigaEventsSection",
    "showNewEpisodesSection",
    "showViewLaterItems",
    "showTrendingMoviesSection",
    "showTrendingSeriesSection",
    "showLiveTvSection",
    "showSquadflixOriginalsSection",
    "showTowersStreamSection",
]


const AppConfigSquadflix = (props: Props) => {
    const intl = useIntl();
    const modalHeaderTypeRef = useRef<ScrollModalApi>();
    const {
        userPreferences,
        updatePreference,
        loadingUpdate
    } = props;

    const toggleValue = async (key: string, e: any) => {
        await updatePreference("squadflixHomePreferences", {
            ...userPreferences.squadflixHomePreferences,
            [key]: e.target.checked
        });
    }

    if (!userPreferences.squadflixHomePreferences) {
        return null;
    }

    return (<>
        <TitlePage icon="fa-solid fa-clapperboard" title="Inicio Squadflix"
                   leftClass="col-12" rightOptions={undefined} titleClass={undefined} rightClass={undefined}
                   disableScroll={undefined} hideSeparator={undefined} fixedHeight={undefined}
                   className={undefined} style={undefined}/>
        <span className="text-muted d-block mb-3">
            <i className="fa-solid fa-circle-info"></i> Puedes cambiar que se muestra en el header de Squadflix.
        </span>
        <div className="user-app-config__bar-buttons mb-4">
            <ButtonV2
                disabled={loadingUpdate}
                onClick={() => modalHeaderTypeRef.current?.open()}
                size="small"
                className="user-app-config__bar-buttons-btn">
                {intl.formatMessage({id: `userAppConfig.squadflix.header-type.${userPreferences.squadflixHomePreferences.headerType}`})}
                <i className="fa-solid fa-pencil ps-2"></i>
            </ButtonV2>
        </div>

        <span className="text-muted d-block mb-3">
            <i className="fa-solid fa-circle-info"></i> Elige las secciones que quieres ver en la pantalla de inicio de Squadflix.
        </span>
        <div className="config-squadflix__toggles">
            {toggles.map((toggle) => {
                const label = intl.formatMessage({id: `userAppConfig.squadflix.${toggle}`});
                const value = (userPreferences.squadflixHomePreferences as any)?.[toggle] ?? false;
                return (
                    <InputToggle className="config-squadflix__toggles-input" disabled={loadingUpdate}
                                 label={label} key={toggle}
                                 customInputPadding="p-0"
                                 onChange={(e) => {
                                     toggleValue(toggle, e);
                                 }} checked={value}/>);
            })}
        </div>
        <ScrollModal ref={modalHeaderTypeRef} header={undefined}>
            {Object.keys(SquadflixHeaderType).map((headerType) => {
                if (isNaN(Number(headerType))) {
                    return null;
                }
                const label = intl.formatMessage({id: `userAppConfig.squadflix.header-type.${headerType}`});
                return (
                    <ButtonV2
                        size="small"
                        className={"user-app-config__bar-buttons-btn w-100 mb-3 mt-2"}
                        disabled={loadingUpdate} key={headerType}
                        onClick={async () => {
                            await updatePreference("squadflixHomePreferences", {
                                ...userPreferences.squadflixHomePreferences,
                                headerType: headerType
                            });
                            modalHeaderTypeRef.current?.close();
                        }}>
                        {label}
                    </ButtonV2>
                );
            })}
        </ScrollModal>

    </>);
}

export default AppConfigSquadflix;
